import React, { useState } from 'react';
import { translate } from '../../Services/translation';
import Icon from '../IconBase/Icon';
import StackedPricesPopup from './StackedPricesPopup';

const StackedPricesLink = (props) => {
  const [showPopup, setShowPopup] = useState(false);

  return (
    <div className="stacked-prices-link">
      <span
        onClick={() => setShowPopup(true)}
        className="stacked-prices-link__label-wrapper"
      >
        <Icon iconCode="info" className="stacked-prices-link__icon" />
        <span className="stacked-prices-link__label">
          {translate('product.stacked-prices-label')}
        </span>
      </span>
      {showPopup && (
        <StackedPricesPopup
          {...props}
          onClosePopup={() => setShowPopup(false)}
        />
      )}
    </div>
  );
};

export default StackedPricesLink;
